import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import TagManagerService from 'services/TagManager';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss';//NOSONAR

let actions = [];

const Brands = (props) => {
    const [clicked, setClicked] = useState(false);
    const isMobile = useViewportMediaQuery(1121)

    useEffect(() => {
        brands && brands.map(brand => {
            brand.checked = brand.active
        })

        actions.push(PubSub.register('close_brands', () => {setClicked(false)}));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const click = () => {
        setClicked(prevState => !prevState);
        PubSub.dispatch('close_categories');
        PubSub.dispatch('close_specification');
    }

    const change = (event, brand) => {
        if (event && event.target.checked) {
            const title_path = brand.Link.replace('/', '').replace('_', ' ');
            const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
            const categoryProduct = title_crumbs.split('/');

            if(!isMobile) {
                TagManagerService.menu(categoryProduct[categoryProduct.length - 2], brand.Name, 'Marca');
            }
        }

        const _brandSelect = brandState.map(item => {
            if(item.Link && item.Link === brand.Link){
                item.checked = event && event.target.checked;
            }
            return item;
        });

        setBrands(_brandSelect);
        PubSub.dispatch('filter_brandSelected', { brands: _brandSelect});
    }

    let { brands } = props;
    const [brandState, setBrands] = useState([]);

    useEffect(() => {
        setBrands(brands);
    }, [brands]);

    if (!(brands && brands[0])) return '';

    brands.sort(function (a, b) {
        if (a.Name < b.Name) { return -1; }
        if (a.Name > b.Name) { return 1; }
        return 0;
    });

    const filterStores = (event) => {

        const value = event.currentTarget ? event.currentTarget.value : '';
        const ul = document.getElementById("list-brand");
        const li = ul.getElementsByTagName('li');
        
        for (let i = 0; i < li.length; i++) {
            const nameBrand = li[i].getElementsByTagName("span")[0];
            const txtValue = (nameBrand.textContent ) || (nameBrand.innerText );

            if (txtValue.toUpperCase().indexOf(value.toUpperCase()) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        }
    }

    const countActive = brandState.filter(brand => brand.active).length;

    return (
        <div className={'catalog-aside-nav' + (clicked ? ' active ' : '')}>
            <div className={"catalog-aside-nav-title-wrap" + (clicked ? ' active ' : '')} onClick={()=> click()}>
                <h4 className="catalog-aside-nav-title">
                    Marca 
                    {!!countActive && <span className="catalog-aside-nav-count">{countActive}</span>}
                </h4>
                <i className={"catalog-aside-view-more" + (clicked ? ' active ' : '')}>{clicked ? '-' : '+'}</i>
            </div>
            {(clicked && (brandState.length > 15)) && <div className="brand-search-aside">
                <input type="text" className="brand-search-input-aside" onChange={(val) => filterStores(val)}/>  
            </div>}
            <ul id='list-brand' className={'catalog-aside-nav-list brands' + (clicked ? ' active' : '')}>
                {(brandState && brandState.length) && brandState.map((brand, i) =>
                    <li className="catalog-aside-nav-item" key={i}>
                        <label>
                            <input type="checkbox"  value={brand.Link} checked={brand.checked || false} onChange={(event) => change(event, brand)} />
                            <span>{brand.Name}</span>
                        </label>
                    </li>)}
            </ul>
        </div>
    )
}

Brands.propTypes = {
    brands: PropTypes.array,
    filter: PropTypes.object
}

export default Brands;
